
// 用户数据模块
import tools from '@/utils/tool'



// const getters = {
//   token: state => state.token,
//   channel: state => state.channel,
//   hasLogin: state => state.hasLogin,
//   hasNumber: state => state.hasNumber,
//   userInfo: state => state.userInfo,
//   userOtherData: state => state.userData,
//   authType: state => state.authType,
// }


export default {
  state: {
    token: tools.data.get("TOKEN") || "",
    channel: false,
    hasLogin: tools.data.get("hasLogin") || false, // 是否登陆
    hasNumber: tools.data.get("hasNumber") || false, // 是否会员
    userInfo: tools.data.get("USERINFO") || {}, // 用户信息
    userData: {}, //用户其他相关信息
    authType: '' // smsLogin:手机号登录注册, accountLogin:密码登录, forgotPwd:忘记密码, changePwd:修改密码, bindMobile:绑定手机号
  },
  getters: {
    token: state => state.token,
    channel: state => state.channel,
    hasLogin: state => tools.data.get("hasLogin") || state.hasLogin,
    hasNumber: state => state.hasNumber,
    userInfo: state => tools.data.get("USERINFO") || state.userInfo,
    userOtherData: state => state.userData,
    authType: state => state.authType,
  },
  mutations: {
    token(state, payload) {
      state.token = payload;
      tools.data.set("TOKEN", payload);
    },
    channel(state, data) {
      state.channel = data;
    },
    // 登录态
    hasLogin(state, data) {
      console.log('====', data)
      state.hasLogin = data;
      tools.data.set('hasLogin', data);
    },
    hasNumber(state, data) {
      state.hasNumber = data;
      tools.data.set('hasNumber', data);
    },
    // 用户信息
    userInfo(state, data) {
      state.userInfo = data;
      tools.data.set("userInfo", data);
    },
    USER_DATA(state, data) {
      state.userData = data;
    },
    AUTH_TYPE(state, data) {
      state.authType = data;
    },
  }
}
